import React, { useEffect, useState } from 'react';
import SearchBar from './SearchBar';
import VideoMedellin from '../assets/videos/Metro_de_Medellín_y_Poblado.mp4'
import VideoRecopilacionPropiedades from '../assets/videos/VIDEO_HOMEPAGE_tamaño_ajustado.mp4'
import VideoCel from '../assets/videos/VIDEO_HOMEPAGE_CEL.mp4'


const Hero = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Activar animaciones después de que el componente se monte
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Detectar si es móvil
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="relative min-h-screen w-full flex items-center justify-center pt-16 md:pt-0">
      <video 
        className="absolute top-0 left-0 w-full h-full object-cover z-0 brightness-[0.3]"
        src={isMobile ? VideoCel : VideoRecopilacionPropiedades}
        autoPlay
        loop
        muted
      />
      <div className="relative z-10 text-center w-full px-4 py-8">
        <h1 className={`text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 text-brand-gold drop-shadow-xl leading-tight transform transition-all duration-1200 ease-out ${
          isLoaded 
            ? 'translate-x-0 opacity-100' 
            : 'translate-x-full opacity-0'
        }`}>
          Tu próxima casa, hoy
        </h1>
        <p className={`text-lg sm:text-xl md:text-2xl mb-8 md:mb-12 text-brand-white font-light tracking-wide px-2 transform transition-all duration-1000 ease-out delay-300 ${
          isLoaded 
            ? 'translate-y-0 opacity-100' 
            : 'translate-y-8 opacity-0'
        }`}>
          Encuentra inmuebles en venta y arriendos
        </p>
        <div className={`backdrop-blur-sm p-4 md:p-8 rounded-xl max-w-6xl mx-auto transform transition-all duration-1000 ease-out delay-500 ${
          isLoaded 
            ? 'translate-y-0 opacity-100 scale-100' 
            : 'translate-y-12 opacity-0 scale-95'
        }`}>
          <SearchBar />
        </div>
      </div>
    </div>
  );
};


export default Hero;
